import { apiRestApi } from "Services/restApi";

import type { SseEchoRequest, SseEchoResponse } from "@regal-voice/regal-client";

export const diagnosticsApi = apiRestApi.injectEndpoints({
    endpoints: (builder) => ({
        sseEcho: builder.mutation<SseEchoResponse, SseEchoRequest>({
            query: (body) => ({
                endpoint: `/diagnostics/sse-echo`,
                method: "POST",
                body,
            }),
        }),
    }),
});

export const { useSseEchoMutation } = diagnosticsApi;
